module.exports = __webpack_public_path__ + "img/ls.70c0502c.png";